(function(){
'use strict';
/* load the sitewide email corrector alongside the currency bar */
(function(){
  var s=document.currentScript||(function(){var a=document.getElementsByTagName('script');return a[a.length-1];})();
  var base=(s&&s.src)?s.src.replace(/stone-currency\.js.*$/,''):'';
  if(!document.getElementById('sa-email-js')){
    var e=document.createElement('script');
    e.id='sa-email-js';e.src=base+'stone-email.js';e.defer=true;
    document.head.appendChild(e);
  }
})();
var BASE='INR';
var CURRENCIES={
  INR:{sym:'₹',label:'INR – Indian Rupee'},
  USD:{sym:'$',label:'USD – US Dollar'},
  GBP:{sym:'£',label:'GBP – British Pound'},
  EUR:{sym:'€',label:'EUR – Euro'},
  AED:{sym:'AED ',label:'AED – UAE Dirham'},
  AUD:{sym:'A$',label:'AUD – Australian Dollar'},
  RUB:{sym:'₽',label:'RUB – Russian Rouble'}
};
var RATES={INR:1,USD:0.0113,GBP:0.0085,EUR:0.0097,AED:0.0415,AUD:0.0172,RUB:0.91};
var cur;
try{cur=localStorage.getItem('sa_currency')||'INR';}catch(e){cur='INR';}
if(!CURRENCIES[cur])cur='INR';

function fetchRates(){
  try{
    fetch('https://open.er-api.com/v6/latest/INR').then(function(r){return r.json();}).then(function(d){
      if(d&&d.rates){
        for(var k in CURRENCIES){if(d.rates[k])RATES[k]=d.rates[k];}
        try{localStorage.setItem('sa_rates',JSON.stringify({t:Date.now(),r:RATES}));}catch(e){}
        if(cur!=='INR')convertAll();
      }
    }).catch(function(){});
  }catch(e){}
}
try{
  var cached=JSON.parse(localStorage.getItem('sa_rates')||'null');
  if(cached&&cached.r&&(Date.now()-cached.t)<43200000){RATES=cached.r;fetchRates();}
  else{fetchRates();}
}catch(e){fetchRates();}

var RX=/Rs\.\s?([\d,]+(?:\.\d{2})?)/;
function groupThousands(n){
  var s=String(Math.round(n));
  var neg=s.charAt(0)==='-'; if(neg)s=s.slice(1);
  var out='';
  for(var i=0;i<s.length;i++){
    if(i>0 && (s.length-i)%3===0) out+=',';
    out+=s.charAt(i);
  }
  return (neg?'-':'')+out;
}
function fmt(v,c){
  var cfg=CURRENCIES[c];
  var n=v*RATES[c];
  return cfg.sym+groupThousands(n);
}
function convertAll(){
  var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null),n,list=[];
  while((n=w.nextNode())){if(RX.test(n.nodeValue))list.push(n);}
  for(var i=0;i<list.length;i++){
    var node=list[i];
    var p=node.parentElement;if(!p)continue;
    if(p.closest('script,style,noscript,#sa-cur-bar'))continue;
    if(!p.dataset.saInr){
      var m=node.nodeValue.match(RX);if(!m)continue;
      p.dataset.saInr=m[1].replace(/,/g,'');
      p.dataset.saTpl=node.nodeValue;
    }
  }
  var els=document.querySelectorAll('[data-sa-inr]');
  for(var j=0;j<els.length;j++){
    var el=els[j],inr=parseFloat(el.dataset.saInr);
    if(isNaN(inr))continue;
    var tw=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),t;
    while((t=tw.nextNode())){
      if(RX.test(t.nodeValue)||t.saOwned){
        var txt=(cur===BASE)?el.dataset.saTpl:el.dataset.saTpl.replace(RX,function(){return fmt(inr,cur);});
        if(t.nodeValue!==txt){t.nodeValue=txt;}
        t.saOwned=true;
        break;
      }
    }
  }
}
function buildUI(){
  var bar=document.getElementById('sa-cur-bar');
  var sel;
  if(!bar){
    var hg=document.getElementById('header-group')||document.body;
    bar=document.createElement('div');bar.id='sa-cur-bar';
    bar.innerHTML='<span class="sa-cur-note">Ships worldwide · Prices in</span><span id="sa-cur"><span class="sa-cur-chip"><span class="sa-cur-code"></span><svg width="8" height="5" viewBox="0 0 8 5" aria-hidden="true"><path d="M0 0l4 5 4-5z" fill="currentColor"/></svg></span><select aria-label="Currency" title="Prices are an approximate conversion. Checkout is in INR."></select></span>';
    if(hg.firstChild){hg.insertBefore(bar,hg.firstChild);}else{hg.appendChild(bar);}
  }
  sel=bar.querySelector('select');
  if(!sel||sel.dataset.saBuilt)return;
  sel.dataset.saBuilt='1';
  for(var k in CURRENCIES){
    var o=document.createElement('option');o.value=k;o.textContent=CURRENCIES[k].label;
    if(k===cur)o.selected=true;
    sel.appendChild(o);
  }
  var chip=bar.querySelector('.sa-cur-chip .sa-cur-code');
  function syncChip(){if(chip)chip.textContent=cur;}
  sel.addEventListener('change',function(){
    cur=sel.value;
    try{localStorage.setItem('sa_currency',cur);}catch(e){}
    syncChip();convertAll();
  });
  syncChip();
}

var t=null;
function kick(){clearTimeout(t);t=setTimeout(function(){buildUI();convertAll();},80);}
function boot(){
  buildUI();convertAll();
  new MutationObserver(function(){kick();}).observe(document.body,{childList:true,subtree:true});
  setInterval(function(){buildUI();if(cur!==BASE)convertAll();},2000);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();